import React, { Component } from 'react';
import { Grid, TextField, Select, MenuItem, } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles';

const locations = [
  "Boston",
  "Chicago",
  "Houston",
  "Los Angeles",
  "Mexico City",
  "Miami",
  "New York",
  "Silicon Valley",
  "São Paulo",
  "Tampa",
  "Washington D.C.",
  "London",
]

class Profile extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;

    return (
      <>
        {this.props.guest_data_capture_fields &&
          Object.keys(this.props.guest_data_capture_fields).map(
            (key, index) => {
              if (key == "guest_company_name" && this.props.guest_data_capture_fields[key] == "Office")
                return (
                  <Grid
                    className={classes.formGroup}
                    key={`profile_grid_${index}`}
                  >
                    <TextField
                      select
                      fullWidth
                      className={classes.inputField}
                      variant={this.props.variant}
                      error={this.props.hasError && this.props.hasError(key)}
                      label="Office"
                      name={key}
                      onChange={this.props.onChange}
                      value={(this.props.values && this.props.values[key]) || ''}
                    >
                      <MenuItem value="" disabled>Select office</MenuItem>
                    {
                      locations.map((l, i) => (
                        <MenuItem value={l} key={`location-${i}`}>{l}</MenuItem>
                      ))
                    }
                    </TextField>
                  </Grid>
                )
              else if (key == "is_alumni")
                return (
                  <Grid
                    className={classes.formGroup}
                    key={`profile_grid_${index}`}
                  >
                    <TextField
                      select
                      fullWidth
                      className={classes.inputField}
                      variant={this.props.variant}
                      error={this.props.hasError && this.props.hasError(key)}
                      label="Are you an alumni?"
                      name={key}
                      onChange={this.props.onChange}
                      value={(this.props.values && this.props.values[key]) || ''}
                    >
                      <MenuItem value={'yes'}>Yes</MenuItem>
                      <MenuItem value={'no'}>No</MenuItem>
                    </TextField>
                  </Grid>
                )
              else if (key == 'is_interested')
                  return (
                    <Grid
                      className={classes.formGroupFullWidth}
                      key={`profile_grid_${index}`}
                    >
                      <TextField
                        select
                        fullWidth
                        className={classes.inputField}
                        variant={this.props.variant}
                        error={this.props.hasError && this.props.hasError(key)}
                        label={this.props.guest_data_capture_fields[key]}
                        name={key}
                        onChange={this.props.onChange}
                        value={(this.props.values && this.props.values[key]) || ''}
                      >
                        <MenuItem value={'yes'}>Yes</MenuItem>
                        <MenuItem value={'no'}>No</MenuItem>
                      </TextField>
                    </Grid>
                  )
              else return (
                <Grid
                  className={classes.formGroup}
                  key={`profile_grid_${index}`}
                >
                  <TextField
                    fullWidth
                    variant={this.props.variant}
                    key={index + '_guest_data_capture_field'}
                    label={this.props.guest_data_capture_fields[key]}
                    error={this.props.hasError && this.props.hasError(key)}
                    helperText={
                      this.props.hasError && this.props.hasError(key)
                        ? this.props.errors[key][0]
                        : null
                    }
                    name={key}
                    onChange={this.props.onChange}
                    value={(this.props.values && this.props.values[key]) || ''}
                    className={classes.inputField}
                  />
                </Grid>
              );
            },
          )}
      </>
    );
  }
}

export default withStyles(useStyles)(Profile);
